import { Box, Flex } from '@chakra-ui/react';

import DashboardDealSummaryCard from '../components/DashboardDealSummaryCard';
import StatusDetails from '../components/StatusDetails';
import YourAdvisorTeamCard from '../components/YourAdvisorTeamCard';
import DashboardDocumentsCard from '../components/documents/DashboardDocumentsCard';
import ReferralProgram from '../components/referral/ReferralProgram';
import { DealWithFarthestState } from '../utils';

const MainDashboard = ({ deal }: { deal: DealWithFarthestState | undefined }) => {
  return (
    <Flex flexDirection={{ base: 'column', lg: 'row' }} columnGap="20px" rowGap="20px">
      <Flex flexDirection="column" gap="20px" w={{ base: 'full', lg: '72%' }}>
        <DashboardDealSummaryCard deal={deal} />
        <StatusDetails deal={deal} />
      </Flex>
      <Box w={{ base: 'full', lg: '28%' }}>
        <ReferralProgram deal={deal} />
        <DashboardDocumentsCard deal={deal} />
        <YourAdvisorTeamCard />
      </Box>
    </Flex>
  );
};

export default MainDashboard;
